/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SearchSurveyMarkDto } from '../../models/search-survey-mark-dto';

export interface SearchForSurveyMark$Params {
  mark_name?: string;
  mark_number?: string;
  stamped_id?: string;
}

export function searchForSurveyMark(
  http: HttpClient,
  rootUrl: string,
  params?: SearchForSurveyMark$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SearchSurveyMarkDto>> {
  const rb = new RequestBuilder(rootUrl, searchForSurveyMark.PATH, 'get');
  if (params) {
    rb.query('mark_name', params.mark_name, {});
    rb.query('mark_number', params.mark_number, {});
    rb.query('stamped_id', params.stamped_id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SearchSurveyMarkDto>;
      }),
    );
}

searchForSurveyMark.PATH = '/search/survey-mark';
